import {dispatchTrackEvent} from "./_tracking";

export default function initGravityForm() {
  submitGravityFormEvent();
  inputFocusGravityFormEvent();
  inputChangeGravityFormEvent();
  errorGravityFormEvent();
}

function submitGravityFormEvent() {
  // ajax confirmation
  window.jQuery(document).on('gform_confirmation_loaded', function (event, formId) {

    const trackingProps = getGravityFormTrackingProps(document.querySelector(`#gform_confirmation_wrapper_${formId}`), formId);
    if (!trackingProps) return;

    dispatchTrackEvent({
      'eventCategory': 'form',
      'eventAction': 'submit',
      eventLabel: trackingProps.name,
      eventValue: trackingProps.value || 200,
      nonInteraction: false,
    }, event.target);

  });
}

function errorGravityFormEvent() {
  // ajax error
  window.jQuery(document).on('gform_post_render', function (event, formId, page) {
    // Only fire when there is an error
    if(!document.querySelector(`#gform_${formId}_validation_container`)) return;

    const trackingProps = getGravityFormTrackingProps(document.querySelector(`#gform_${formId}_validation_container`), formId);
    if (!trackingProps) return;

    dispatchTrackEvent({
      'eventCategory': 'form',
      'eventAction': 'error',
      eventLabel: trackingProps.name,
      eventValue: 5,
      nonInteraction: true,
    }, event.target);

    inputFocusGravityFormEvent();
    inputChangeGravityFormEvent();
  });
}

function inputFocusGravityFormEvent() {
  window.jQuery('.gform_wrapper form').on('focus', 'input, textarea, select', function (event) {
    // Don't fire for submit event
    if(event.target.attributes?.type?.value === 'submit') return;

    const trackingProps = getGravityFormTrackingProps(event.target);

    dispatchTrackEvent({
      'eventCategory': 'form',
      'eventAction': 'field focus',
      eventLabel: trackingProps.name,
      eventValue: trackingProps.value || 20,
      nonInteraction: false,
    }, event.target);
  });
}

function inputChangeGravityFormEvent() {
  window.jQuery('.gform_wrapper form').on('change', 'input, textarea, select', function (event) {
    const trackingProps = getGravityFormTrackingProps(event.target);

    dispatchTrackEvent({
      'eventCategory': 'form',
      'eventAction': 'field change',
      eventLabel: trackingProps.name,
      eventValue: trackingProps.value || 10,
      nonInteraction: false,
    }, event.target);
  });
}

/**
 * Returns tracking values
 * @param target
 * @param formID
 * @returns {{name: string, value: string}}
 */
function getGravityFormTrackingProps(target, formID = null) {
  return {
    name: target.closest('[data-conversion-name]').getAttribute('data-conversion-name') || target.placeholder?.toLowerCase() || formID,
    value: target.closest('[data-conversion-value]').getAttribute('data-conversion-value'),
  };
}
